import { Component, Input, Pipe, PipeTransform, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { takeUntil } from 'rxjs';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { DeliveryType } from '../../shared-new/enums/delivery-type.enum';
import { EmailEventType } from '../../shared-new/enums/email-activity.enum';
import { SentMailLogModel } from '../../shared-new/models/sent-mail-log.model';
import { MailFacade } from '../../shared-new/store/mail/mail.facade';
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(value: any) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
@Component({
  selector: 'app-communication-log-detail-modal',
  templateUrl: './communication-log-detail-modal.component.html',
  styleUrls: ['./communication-log-detail-modal.component.scss']
})
export class CommunicationLogDetailModalComponent extends BaseUnsubscribeComponent implements OnInit {
  @Input() public sentMailLogId: number;

  sentMailLogs$ = this.mailFacade.sentMailLogs$;
  loading$ = this.mailFacade.loading$;
  error$ = this.mailFacade.error$;

  email: SentMailLogModel;
  sms: SentMailLogModel;
  whatsapp: SentMailLogModel;

  constructor(public modal: NgbActiveModal, private mailFacade: MailFacade) {
    super();
    this.email = null;
    this.sms = null;
    this.whatsapp = null;
  }

  ngOnInit(): void {
    this.mailFacade.loadSentMailLogs(this.sentMailLogId);
    this.attachEvents();
  }

  getColorClass(event: any) {
    return `study-status-box-${event.eventBehaviourClassId}`;
  }
  getWhatsAppColorClass(event: any) {
    return `whatsapp-status-box-${event.statusId}`;
  }
  getSMSColorClass(event: any) {
    return `sms-status-box-${event.statusId}`;
  }

  private attachEvents() {
    this.sentMailLogs$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      if (response) {
        var mailLog = response;
        
        if (mailLog.deliveryTypeId == DeliveryType.Email) {
          this.sms = null;
          this.whatsapp = null;
          this.email = mailLog;
        } else if (mailLog.deliveryTypeId == DeliveryType.SMS) {
          this.email = null;
          this.sms = mailLog.isSMS ? mailLog : null;          
          this.whatsapp = mailLog.isWhatsApp ? mailLog : null;
        } else {
          this.email = mailLog;
          this.sms = mailLog.isSMS ? mailLog : null;
          this.whatsapp = mailLog.isWhatsApp ? mailLog : null;
        }
      }
    });
  }
}
